import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function CountryOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const value = String(_get(option, 'value', ''));

  return (
    <div
      className={classNames(styles.countryOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      <span className={classNames(styles.flag, styles[value.toLowerCase()])} />
      {getOptionLabel(option, t)}
    </div>
  );
}
